import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface ICountProjectTypesState {
  state: QueryState;
  projectTypes: { projectType: string; count: number }[];
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const CountProjectTypesEmptyState: ICountProjectTypesState = {
  state: QueryState.UNDEFINED,
  projectTypes: [],
  error: null,
  accessToken: undefined
};
